import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CUSTOMER_IMPERSONATION_KEY } from '../../services/customerApi';

// Entrada de la impersonación «Ver como cliente»: el portal partner abre esta
// ruta en pestaña nueva con ?token=<jwt de cliente solo-lectura, 15 min>.
// Guardamos el token en sessionStorage (POR-PESTAÑA: no pisa sesiones reales
// de cliente en otras pestañas) y recargamos de verdad para que servicios y
// contextos se re-inicialicen desde cero con la sesión impersonada.

const CustomerImpersonationEntry: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      sessionStorage.setItem(CUSTOMER_IMPERSONATION_KEY, token);
      window.location.replace('/customer/account');
    } else {
      window.location.replace('/customer/login');
    }
  }, [searchParams]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {t('customer.impersonation.entering', 'Abriendo la vista de cliente (solo lectura)...')}
      </Typography>
    </Box>
  );
};

export default CustomerImpersonationEntry;
